<template>
  <div class="message-wrap">
    <div class="message-search">
      <!-- 顶部搜索块 -->
      <el-form :inline="true" :model="formData" class="search-form" ref="searchFormRef" size="small">
        <el-form-item label="关键字" style="min-width: 10%">
          <el-input @keyup.enter.native="handleSearch" v-model="formData.remindingTitle" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间" style="min-width: 260px">
          <el-date-picker
            clearable
            class="max-picker"
            v-model="dataTime"
            type="daterange"
            start-placeholder="起始时间"
            end-placeholder="终止时间"
            value-format="timestamp"
            @change="handleSearch"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关联订单/批次" style="min-width: 15%">
          <el-input @keyup.enter.native="handleSearch" v-model="formData.orderOrContainerId" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="商品编码" style="min-width: 10%">
          <el-input @keyup.enter.native="handleSearch" v-model="formData.goodsCode" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="收藏">
          <el-select v-model="formData.isCollect" placeholder="不限" clearable @change="handleSearch">
            <el-option v-for="item in collectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formData.isRead" placeholder="请选择状态" clearable @change="handleSearch">
            <el-option label="全部" value=""></el-option>
            <el-option label="已读" value="1"></el-option>
            <el-option label="未读" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发件人">
          <el-input @keyup.enter.native="handleSearch" v-model="formData.createUserName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item class="custom-form-btn">
          <el-button class="search-btn btn-gray" @click="handleReset">重置</el-button>
          <el-button class="search-btn btn-blue" @click="handleSearch">搜索</el-button>
          <el-button class="search-btn btn-green" @click="showMessageDialog">发消息</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="message-content" v-loading="messageListLoading">
      <div class="message-left-wrap">
        <div
          class="message-content-left"
          :class="{ 'flex-center': leftIsEmpty }"
          v-infinite-scroll="load"
          :infinite-scroll-disabled="disabled"
          :infinite-scroll-immediate="false"
        >
          <!-- 左侧收发列表 -->
          <div v-if="!leftIsEmpty" class="message-list">
            <div
              v-for="(item, itemIndex) in messageList"
              :key="itemIndex"
              class="message-list-item"
              :class="{ 'active-item': activeId && item.messageGroupId === activeId, 'active-sys-item': sysMsgId && sysMsgId === item.id }"
              @click.stop="handleMessageItem(item)"
            >
              <el-badge :is-dot="item.readLevel == 2 && item.forwardType == 0 ? true : false"></el-badge>
              <el-checkbox v-model="item.isChecked" class="pos-ab"></el-checkbox>
              <div class="text-overflow text-cursor">
                <span :style="{ color: '#fff', padding: '0 5px', backgroundColor: prefixColor(item, 'createUserName') }">{{
                  prefix(item, "createUserName")
                }}</span>
                <span :style="{ color: prefixColor(item, 'createUserName') }">{{ item.createUserName }}</span>
                {{ ` 发送于 ${dataTimeFn(item.createTime)}` }}
                <!-- <span v-if="item.orderId" style="margin-left: 25px">{{ `[关联订单: ${item.orderId}]` }}</span> -->
              </div>
              <div class="message-info">
                <span class="label">标题：</span>
                <span class="text-content text-overflow">{{ item.remindingTitle }}</span>
              </div>
              <div class="message-info">
                <span class="label">内容：</span>
                <span class="html-content text-overflow">
                  <div v-html="item.remindingContent" class="text-overflow"></div>
                </span>
              </div>
              <i v-if="item.isCollect == '1' && item.createUserName !== 'system'" class="el-icon-star-on collect-icon"></i>
            </div>
          </div>
          <span v-else>暂无消息</span>
        </div>
        <div class="pagination-footer">
          <el-pagination
            small
            @current-change="handleCurrentChange"
            :current-page="formData.pageNum"
            :pager-count="3"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="formData.pageSize"
            layout="total, prev, pager, next"
            :total="messageTotal"
          ></el-pagination>
          <div>
            <el-button size="mini" class="search-btn btn-blue" @click="handleItemRead">批量已读</el-button>
            <el-button size="mini" class="search-btn btn-blue" @click="handleAllRead">全部已读</el-button>
          </div>
        </div>
      </div>
      <div v-if="activeId && messageDetailList.length" class="message-content-right">
        <!-- 回复 -->
        <div class="send-message-wrap" :class="{ reply: showReply }">
          <message-form
            ref="messageFormRef"
            :info="activeItem"
            :messageGroup="messageDetailList"
            submit-url="/system/message2/reply"
            @refreshData="refreshData"
          />
        </div>
        <!-- 过往收发详情列表 -->
        <div v-for="(item, index) in messageDetailList" class="message-list-item" :class="{ 'history-message-item': index !== 0 }">
          <h3 :class="{ 'first-title': index === 0 && item.createUserName !== 'system' && activeItem.isReply == 1 }">{{ item.remindingTitle }}</h3>
          <div class="status-info">
            <p v-if="item.isRead == '1' && item.forwardType == '1' && !item.responsibleUserId" class="customer-status read">
              <span>客户已读-</span>
              <span>{{ dataTimeFn(item.readTime)  }}</span>
            </p>
            <p v-if="item.isRead == '0' && item.forwardType == '1' && !item.responsibleUserId" class="customer-status unread">
              <span>客户未读</span>
            </p>
            <p v-if="index === 0 && item.clientDelFlag == '1'" class="customer-status delete">
              <span>客户已删除-</span>
              <span>{{ dataTimeFn(item.clientDelTime)  }}</span>
            </p>
          </div>
          <div class="send-info">
            <span>
              发送人：
              <span :style="{ color: '#fff', padding: '0 5px', backgroundColor: prefixColor(item, 'createUserName') }">{{
                prefix(item, "createUserName")
              }}</span>
              <span :style="{ color: prefixColor(item, 'createUserName') }">{{ item.createUserName }}</span>
            </span>
            <span>
              接收人：
              <span :style="{ color: '#fff', padding: '0 5px', backgroundColor: prefixColor(item, 'remindingUserName') }">{{
                prefix(item, "remindingUserName")
              }}</span>
               <el-popover
                   placement="top-start"
                   width="200"
                   trigger="hover"
                   :content="item.remindingUserName">
                  <span slot="reference" style="white-space:nowrap;overflow: hidden;text-overflow: ellipsis;width: 200px;display: inline-block;line-height: 17px;" :style="{ color: prefixColor(item, 'remindingUserName') }">
                     {{ item.remindingUserName }}
                  </span>
              </el-popover>

            </span>
            <span>{{ `发送时间：${dataTimeFn(item.createTime)}` }}</span>
          </div>
          <div class="responsible danger-text" v-if="item.responsibleUserId">
            {{ `${item.messageUser} 于 ${dataTimeFn(item.createTime)} @${item.responsibleUserName}` }}
          </div>
          <div class="rich-text-content">
            <div v-html="item.remindingContent"></div>
          </div>
          <el-form label-width="100px" label-position="left" class="history-detail-form">
            <el-form-item label-width="0px">
              <el-col :span="6">
                <el-form-item label="关联订单：">
                  <span class="under-text primary-text" @click="toOrderDetail(item)">
                    {{ item.orderId || "无" }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="商品编码：">
                  <span class="under-text primary-text" @click="toGoodsDetail(item)">
                    {{ item.goodsCode || "无" }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="2">
                <el-form-item label="关联批次：">
                  <span class="under-text primary-text" @click="toFBA">{{ item.containerBatchNo || "无" }}</span>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="附件：">
              <div v-if="item.fileModels && item.fileModels.length" class="annex-list">
                <div class="annex-list-item" v-for="(annex,newIndex) in item.fileModels" :key="newIndex">
                  <img v-if="isImage(annex.filePath)" @click="imgclick(annex.filePath, true)" :src="annex.filePath" alt="">
                  <span class="under-text primary-text file-name text-overflow" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    annex.fileName
                  }}</span>
                  <!--<span
                    class="under-text primary-text"
                    @click="downloadFile(annex.fileName, annex.filePath)"
                  >
                    下载
                  </span>-->
                </div>
              </div>
              <span v-else class="under-text primary-text">无</span>
            </el-form-item>
          </el-form>
          <div class="history-text" v-if="messageDetailList.length > 1 && index === 0">之前的对话记录</div>
        </div>
        <!-- 右上角操作按钮：回复、收藏、发送、取消 -->
        <div class="send-list-operate">
          <el-button v-if="activeItem.readLevel == 2 && activeItem.forwardType == 0" size="small" class="search-btn btn-blue" @click="handleRead(activeItem)">已读</el-button>
          <el-button
            v-if="messageDetailList.length && messageDetailList[0].isRead == '0' && messageDetailList[0].forwardType == '1'"
            size="small"
            class="search-btn btn-green"
            @click="handleRevert(activeItem)"
            >撤回</el-button
          >
          <div v-if="!showReply">
            <el-button size="small" class="search-btn" :class="activeItem.isCollect == 1 ? 'btn-gray' : 'btn-blue'" @click="handleCollect">{{
              activeItem.isCollect == 1 ? "已收藏" : "收藏"
            }}</el-button>
            <el-button v-if="activeItem.isReply == 1" size="small" class="search-btn btn-blue" @click="handleReply">回复</el-button>
            <el-button v-if="activeItem.isReply == 1" size="small" class="search-btn btn-blue" @click="handleAt">@</el-button>
          </div>
          <div v-else>
            <el-button size="small" class="search-btn btn-gray" @click="handleCancel">取消</el-button>
            <el-button size="small" class="search-btn btn-blue" @click="handleSend('messageFormRef')">发送</el-button>
          </div>
        </div>
      </div>
      <div v-else-if="messageList.length && !activeId && sysMsgId" class="message-content-right">
        <div class="message-list-item">
          <h3>{{ activeItem.remindingTitle }}</h3>
          <div class="send-info">
            <span>
              发送人：
              <span :style="{ color: '#fff', padding: '0 5px', backgroundColor: prefixColor(activeItem, 'createUserName') }">{{
                prefix(activeItem, "createUserName")
              }}</span>
              <span :style="{ color: prefixColor(activeItem, 'createUserName') }">{{ activeItem.createUserName }}</span>
            </span>
            <span>
              接收人：
              <span :style="{ color: '#fff', padding: '0 5px', backgroundColor: prefixColor(activeItem, 'remindingUserName') }">{{
                prefix(activeItem, "remindingUserName")
              }}</span>

             <el-popover
                 placement="top-start"
                 width="200"
                 trigger="hover"
                 :content="activeItem.remindingUserName">
                 <span slot="reference" style="white-space:nowrap;overflow: hidden;text-overflow: ellipsis;width: 200px;display: inline-block;line-height: 17px;" :style="{ color: prefixColor(activeItem, 'remindingUserName') }">
                   {{ activeItem.remindingUserName }}
                 </span>
              </el-popover>

            </span>
            <span>{{ `发送时间：${dataTimeFn(activeItem.createTime)}` }}</span>
          </div>
          <div class="rich-text-content">
            <div v-html="activeItem.remindingContent"></div>
          </div>
          <el-form label-width="100px" label-position="left" class="history-detail-form">
            <el-form-item label-width="0px">
              <el-col :span="6">
                <el-form-item label="关联订单：">
                  <span class="under-text primary-text" @click="toOrderDetail(activeItem)">
                    {{ activeItem.orderId || "无" }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="商品编码：">
                  <span class="under-text primary-text" @click="toGoodsDetail(activeItem)">
                    {{ activeItem.goodsCode || "无" }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="2">
                <el-form-item label="关联批次：">
                  <span class="under-text primary-text" @click="toFBA">{{ activeItem.containerBatchNo || "无" }}</span>
                </el-form-item>
              </el-col>
            </el-form-item>
            <!-- <el-form-item label="附件">
              <div v-if="activeItem.fileModels && activeItem.fileModels.length" class="annex-list">
                <div class="annex-list-item" v-for="annex in activeItem.fileModels">
                  <span class="under-text primary-text file-name text-overflow" @click="downloadFile(annex.fileName, annex.filePath)">{{
                    annex.fileName
                  }}</span>
                  <span class="under-text primary-text" @click="downloadFile(annex.fileName, annex.filePath)">下载</span>
                </div>
              </div>
              <span v-else class="under-text primary-text">无</span>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="send-list-operate">
          <el-button v-if="activeItem.readLevel == 2" size="small" class="search-btn btn-blue" @click="handleRead(activeItem)">已读</el-button>
          <!-- <el-button size="small" class="search-btn btn-gray" @click="handleCollect">{{ activeItem.isCollect == 1 ? "已收藏" : "收藏" }}</el-button> -->
        </div>
      </div>
      <div v-else class="message-content-right flex-center">暂无对话</div>
    </div>
    <!-- 发消息弹窗 -->
    <el-dialog title="发送消息" :visible.sync="messageDialogVisible" @close="handleCloseDialog">
      <message-form ref="messageDialogFormRef" submit-url="system/message2/sandMessageNew" @setLoading="sendLoading = true"
                    @setNoLoading="sendLoading = false" @refreshData="refreshDialogData" />
      <div slot="footer" class="dialog-footer">
        <el-button class="search-btn btn-gray" @click="handleCloseDialog">取消</el-button>
        <el-button :loading="sendLoading" class="search-btn btn-blue" @click="handleSend('messageDialogFormRef')">发送</el-button>
      </div>
    </el-dialog>
    <!-- @担当 -->
    <el-dialog title="分配用户" :visible.sync="distributionVisible" width="30%">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="担当：">
          <el-select v-model="responsibleUserId" filterable placeholder="输入用户名进行搜素">
            <el-option v-for="item in staffList" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="distributionVisible = !distributionVisible">取消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmDistribution">提交</el-button>
      </span>
    </el-dialog>
    <!--图片放大-->
    <el-dialog title="" :visible.sync="visible" width="70%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
    </el-dialog>
  </div>
</template>

<script>
import { dataTimeFn, getTime, prefix, prefixColor } from "@/assets/js/utils";
import MessageForm from "./components/messageForm.vue";

export default {
  name: "message",
  // name: "newMessage/index",
  components: {
    MessageForm,
  },
  data() {
    return {
      formData: {
        createUserName: "",
        remindingTitle: "",
        isCollect: "",
        orderOrContainerId: "",
        goodsCode: "",
        pageSize: 50,
        pageNum: 1,
        isRead: "",
      },
      dataTime: [],
      collectList: [
        {
          value: 1,
          label: "收藏",
        },
        {
          value: "",
          label: "不限",
        },
      ],
      messageListLoading: false,
      messageIsEmpty: false,
      messageList: [],
      messageTotal: 0,
      activeId: "",
      activeItem: null,
      messageDetailList: [],
      showReply: false,
      messageDialogVisible: false,
      dataTimeFn,
      getTime,
      leftIsEmpty: false,
      username: "",
      distributionVisible: false,
      staffList: [],
      responsibleUserId: "",
      sysMsgId: "",
      prefix,
      prefixColor,
      visible: false,
      imgurl: "",
      sendLoading: false
    };
  },
  computed: {
    noMore() {
      return this.messageList.length >= this.messageTotal;
    },
    disabled() {
      return this.messageListLoading || this.noMore;
    },
  },
  mounted() {
    this.username = sessionStorage.getItem("username");
    this.getStaffs();
    this.getMessageList();
  },
  methods: {
    imgclick(url) {
      this.visible = true;
      this.imgurl = url;
    },
    isImage(filename) {
      var ext = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
      return (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif');
    },
    // 批量已读
    handleItemRead() {
      let arr = this.messageList.filter(v=>{
        return v.isChecked
      }).map(item=>{
        return item.id
      })
      if(arr.length === 0){
        return this.$message.error('请先勾选消息');
      }
      this.$confirm("确定要把所选信息处理成【已读】吗？", {
        confirmButtonText: "是",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "否",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
          .then(async () => {
            const params = {
              idList: arr
            }
            const { data: res } = await this.$http.post("system/message2/batchRead", params);
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.getMessageList();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {});
    },
    // 全部已读
    handleAllRead() {
      this.$confirm("确定要把所有信息处理成【已读】吗？", {
        confirmButtonText: "是",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "否",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.$http.get("system/message2/allRead");
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.getMessageList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
    },
    handleRead(item) {
      this.$http
        .get(`system/message2/isRead/${item.id}`)
        .then(({ data: res }) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.getMessageList();
          } else {
            this.$message.success(res.message);
          }
        })
        .catch(() => {
          this.$message.success("操作失败");
        });
    },
    handleRevert() {
      const item = this.messageDetailList[0];
      this.$confirm("确定撤回吗？", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      }).then(async () => {
        const { data: res } = await this.$http.get(`system/message2/revocation/${item.id}`);
        if (res.code === 200) {
          this.$message.success("操作成功");
          this.getMessageList();
        } else {
          this.$message.success("操作失败");
        }
      });
    },
    handleAt() {
      this.distributionVisible = true;
    },
    async getStaffs() {
      const { data: res } = await this.$http.get("emp/empSystemManage/listAll");
      this.staffList = res.data;
    },
    async confirmDistribution() {
      const params = {
        id: this.messageDetailList[0].id,
        responsibleUserId: this.responsibleUserId,
        responsibleUserName: this.staffList.find((item) => item.userId === this.responsibleUserId)?.userName,
      };
      this.$http.post("system/message2/undertake", params).then(({ data: res }) => {
        this.distributionVisible = false;
        // this.getMessageList();
        this.getRightDetail();
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleCurrentChange(newPage) {
      this.formData.pageNum = newPage;
      this.getMessageList();
    },
    getMessageList(activeId) {
      this.messageListLoading = true;
      const hasTime = this.dataTime && this.dataTime.length;
      const endTime = hasTime && this.getTime(this.dataTime[1]);
      const endTimeStr = endTime && endTime.replace("00:00:00", "23:59:59");
      //获取信息列表
      this.$http
        .get("/system/message2/list", {
          params: {
            ...this.formData,
            createTimeStart: hasTime ? this.getTime(this.dataTime[0]) : "",
            createTimeEnd: hasTime ? endTimeStr : "",
          },
          headers: {
            noLoading: activeId ? true : false,
          },
        })
        .then(({ data: res }) => {
          if (res.code === 200 && res.data && res.data.list) {
            if (!res.data.list.length) {
              this.messageDetailList = [];
              this.messageList = [];
              this.messageTotal = res.data.total;
            } else {
              this.messageTotal = res.data.total;
              const hasIdArray = res.data.list.filter((item) => item.id === activeId);
              if (!hasIdArray.length) {
                this.activeItem = res.data.list[0] || null;
                this.activeId = res.data.list[0].messageGroupId || "";
                if (!res.data.list[0].messageGroupId) {
                  this.sysMsgId = res.data.list[0].id;
                }
              } else {
                this.activeItem = hasIdArray[0] || null;
                this.activeId = hasIdArray[0].messageGroupId || "";
                if (!hasIdArray[0].messageGroupId) {
                  this.sysMsgId = hasIdArray[0].id;
                }
              }
              // this.messageList = res.data.list;
              this.messageList = res.data.list.map(v=>{
                return{
                  ...v,
                  isChecked: false
                }
              })
              // this.activeItem = res.data.list[0] || null;
              // this.activeId = res.data.list[0].messageGroupId || "";
              // if (!res.data.list[0].messageGroupId) {
              //   this.sysMsgId = res.data.list[0].id;
              // }
              // this.messageList = res.data.list.map((msg) => {
              //   if (msg.id === res.data.list[0].id) {
              //     msg.unreadCount = 0;
              //   }
              //   return msg;
              // });
              console.log('activeId',activeId)
              this.getRightDetail(activeId);
            }
          }
        })
        .finally(() => {
          if (!this.messageList.length) {
            this.leftIsEmpty = true;
          } else {
            this.leftIsEmpty = false;
          }
          this.messageListLoading = false;
        });
    },
    getRightDetail(activeId) {
      if (this.activeId) {
        this.$http
          .get("/system/message2/groupList", {
            params: {
              messageGroupId: this.activeId,
              remindingUserName: this.activeItem.remindingUserName,
            },
            headers: {
              noLoading: activeId ? true : false,
            },
          })
          .then(({ data: res }) => {
            if (res.code === 200) {
              this.messageDetailList = res.data || [];
              this.activeItem.newRemindingTitle = this.messageDetailList[0].remindingTitle
            }
          })
          .catch(() => {
            this.$message.error("接口请求失败");
          });
      }
      if (this.sysMsgId) {
        this.$http
          .get(`cmUser/message/systemMessageInfo/${this.sysMsgId}`, {
            headers: {
              isCurLoad: activeId ? true : false,
            },
          })
          .then(({ data: res }) => {
            if (res.code === 200 && res.data) {
              if (this.activeItem.createUserName !== "system") {
                this.activeItem = res.data.length ? res.data[0] : null;
              }
            }
          });
      }
    },
    load() {
      // this.formData.pageNum += 1;
      // this.getMessageList(true);
    },
    handleSearch() {
      this.formData.pageNum = 1;
      this.sysMsgId = "";
      // 搜索
      this.getMessageList();
    },
    showMessageDialog() {
      this.messageDialogVisible = true;
    },
    handleMessageItem(item) {
      this.activeItem = item;
      if (item.messageGroupId && item.createUserName !== "system") {
        this.sysMsgId = "";
        // 切换左侧邮件
        if (this.activeId != item.messageGroupId) {
          this.showReply = false;
          this.activeId = item.messageGroupId;
          this.getRightDetail();
        }
      } else {
        this.activeId = "";
        if (this.sysMsgId != item.id) {
          this.sysMsgId = item.id;
          this.getRightDetail();
        }
      }
    },
    handleReply() {
      // 回复
      this.showReply = !this.showReply;
    },
    handleReset() {
      // 重置
      this.formData.createUserName = "";
      this.formData.remindingTitle = "";
      this.formData.remindingTitle = "";
      this.formData.isCollect = "";
      this.formData.isRead = "";
      this.formData.orderOrContainerId = "";
      this.dataTime = [];
      this.sysMsgId = '';
      this.getMessageList();
    },
    handleSend(refName) {
      // this.sendLoading = true;
      // 回复框展开时的发送按钮
      this.$refs[refName].submit();
    },
    handleCancel() {
      // 回复框取消
      this.showReply = false;
      this.$refs.messageFormRef.formReset();
    },
    handleCollect() {
      // 收藏 系统通知没有操作
      this.activeItem.isCollect = this.activeItem.isCollect == 1 ? 0 : 1;
      this.$http
        .get("/system/message2/collect", {
          params: {
            isCollect: this.activeItem.isCollect,
            messageGroupId: this.activeItem.messageGroupId,
          },
        })
        .then(({ data: res }) => {
          if (res.code === 200) {
            this.messageList.forEach((item) => {
              if (item.messageGroupId === this.activeId) {
                // 更改列表收藏的值
                this.getMessageList(item.id);
                // item.isCollect = this.activeItem.isCollect;
              }
            });
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        });
    },
    handleCloseDialog() {
      this.messageDialogVisible = false;
      this.sendLoading = false;
      // this.$refs.messageDialogFormRef.formReset();
    },
    toOrderDetail(row) {
      if (row.orderId) {
        this.$http
          .get("/cmUser/message2/orderIsExist", { params: { orderId: row.orderId } })
          .then(({ data: res }) => {
            if (res.code === 200) {
              if (!res.data) {
                this.$message.warning("订单号不存在");
              } else {
                if (row.orderId.indexOf("R") != -1 || row.orderId.indexOf("C") != -1) {
                  //R出现或者C出现
                  this.$router.push({
                    //充值记录
                    name: "rechargeList",
                    query: {
                      rechargeNo: row.orderId,
                    },
                  });
                } else {
                  //订单详情
                  this.$router.push({
                    name: "orderDetail",
                    query: {
                      id: row.orderId,
                      isEdit: "0",
                    },
                  });
                }
              }
            }
          })
          .catch(() => {
            this.$message.warning("接口异常");
          });
      } else {
        // 订单列表
        this.$router.push("orders");
      }
    },
    toFBA() {
      this.$router.push("/Container");
    },
    toGoodsDetail(row){
      if (row.purchaseGoodsId){
        this.$router.push({
          name: 'goodsDetails',
          query: {
            id: row.purchaseGoodsId
          }
        })
      }
    },
    refreshData() {
      this.handleCancel();
      this.getMessageList();
      // this.getRightDetail();
    },
    refreshDialogData() {
      this.handleCloseDialog();
      this.getMessageList();
      this.$refs.messageDialogFormRef.formReset();
    },
    downloadFile(name, url) {
      let formdata = new FormData();
      formdata.append("FileUrl", url);
      formdata.append("FileName", name);
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "" }); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", name); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>

<style scoped lang="less">
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.under-text {
  text-decoration: underline;
  cursor: pointer;
}
.danger-text {
  color: #f56c6c;
}
.primary-text {
  color: #3e8ef7;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.message-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px - 45px - 39px);
  color: #606266;
  ::v-deep .el-empty {
    width: 30%;
  }
  .message-search {
    background-color: #fff;
    padding: 15px;
    .search-form {
      display: flex;
      ::v-deep .el-form-item {
        margin-bottom: 0;
        display: flex;
        flex: 1;
      }
      ::v-deep .el-form-item__label {
        flex: none;
      }
      ::v-deep .el-form-item__content {
        flex: 1;
      }
      .max-picker {
        width: auto;
      }
      .custom-form-btn {
        min-width: 270px;
        text-align: right;
        margin-right: 0;
      }
    }
  }
  .message-content {
    flex: 1;
    display: flex;
    margin-top: 15px;
    overflow: hidden;
    .message-left-wrap {
      display: flex;
      flex-direction: column;
      width: 35%;
      ::v-deep .el-pagination {
        text-align: left !important;
      }
    }
    .message-content-left {
      margin-right: 15px;
      flex: none;
      overflow-y: auto;
      height: calc(100% - 43px);
      .message-list {
        width: 100%;
        .message-list-item {
          width: 100%;
          background: #fff;
          border-radius: 5px;
          padding: 15px;
          margin-bottom: 15px;
          line-height: 28px;
          border: 1px solid transparent;
          cursor: pointer;
          position: relative;
          .pos-ab{
            position: absolute;
            right: 30px;
            top: 2px;
          }
          .text-cursor {
            cursor: pointer;
          }
          .message-info {
            cursor: pointer;
            display: flex;
            .html-content {
              overflow: hidden;
              height: 28px;
              max-width: 80%;
              ::v-deep img {
                display: none;
              }
            }
          }
          .text-content {
            max-width: 80%;
          }
          .collect-icon {
            position: absolute;
            top: 3px;
            right: 3px;
            color: #595bb3;
            font-size: 24px;
          }
        }
        .active-item {
          border: 1px solid #f59a23;
        }
        .active-sys-item {
          border: 1px solid #f59a23;
        }
      }
    }
    .message-content-right {
      flex: 1;
      background-color: #fff;
      border-radius: 5px;
      padding: 15px;
      position: relative;
      overflow-y: auto;
      .send-message-wrap {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.5s;
      }
      .reply {
        max-height: 800px;
        transition: max-height 0.5s;
      }
      .send-list-operate {
        position: absolute;
        top: 15px;
        right: 10px;
        display: flex;
        align-items: center;
        // .customer-text {
        //   margin-right: 10px;
        //   align-items: center;
        // }
      }
      .message-list-item {
        border-bottom: 3px solid #ccc;
        padding-bottom: 20px;
        position: relative;
        .history-detail-form {
          ::v-deep .el-form-item {
            margin-bottom: 0;
          }
        }
        .history-text {
          position: absolute;
          left: 50%;
          bottom: -20px;
          background: #fff;
          transform: translateX(-50%);
          padding: 10px;
        }
        h3 {
          min-height: 19px;
          font-size: 14px;
          margin: 10px 0;
          white-space: pre-wrap;
        }
        .first-title {
          max-width: 42%;
        }
        .status-info {
          display: flex;
          .customer-status {
            margin-right: 10px;
          }
          .read {
            color: #f59a23;
          }
          .delete {
            color: #f56c6c;
          }
          .unread {
            color: #909399;
          }
        }
        .send-info {
          display: flex;
          background-color: #fff;
          line-height: 50px;
          gap: 35px;
        }
        .rich-text-content {
          margin: 15px 0;
          padding: 50px 15px;
          background: #f2f2f2;
          ::v-deep img {
            max-width: 100%;
          }
        }
        .association {
          display: flex;
          gap: 35px;
        }
        .annex-list {
          width: 54%;
          .annex-list-item {
            display: flex;
            /*justify-content: space-between;*/
            height: 30px;
            margin-bottom: 10px;
            img{
              width: 50px;
              height: 30px;
              margin-right: 20px;
              cursor: pointer;
            }
            .file-name {
              max-width: 70%;
            }
          }
        }
      }
      .history-message-item {
        margin-left: 2em;
        padding: 20px 0;
      }
    }
    .pagination-footer {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      margin-right: 5px;
    }
  }
}
</style>
